import { Layout } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';
import { MacroStructureCard } from './macro-structure-card';

interface MacroStructure {
    type: string;
    description: string;
    isPrimary?: boolean;
    chiasm?: {
        pattern: string;
        range?: string;
        confidence?: string;
    };
    sources?: any[];
}

interface MacroStructureOverviewCardProps {
    structures: MacroStructure[];
    isExpanded: boolean;
    onToggleExpansion: () => void;
    thumbnailUrl?: string;
}

export function MacroStructureOverviewCard({ structures, isExpanded, onToggleExpansion, thumbnailUrl }: MacroStructureOverviewCardProps) {
    if (!structures || structures.length === 0) return null;

    return (
        <DiscoveryCard
            isExpanded={isExpanded}
            onToggle={onToggleExpansion}
            icon={Layout}
            thumbnailUrl={thumbnailUrl}
            header={
                <div className="flex flex-col gap-1">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/50">Architectural Framework</div>
                    <h3 className="text-xl font-serif font-medium text-foreground/90 leading-tight">Book Structural Backbone</h3>
                </div>
            }
        >
            <div className="pt-4 space-y-8">
                <p className="text-xs text-muted-foreground italic mb-2">
                    Scholars have identified these overarching structures that organize the entire work.
                </p>

                <div className="grid gap-8">
                    {structures.map((structure, idx) => (
                        <div key={idx} className="relative pl-6 border-l border-primary/10 space-y-4">
                            <MacroStructureCard structure={structure} />
                        </div>
                    ))}
                </div>
            </div>
        </DiscoveryCard>
    );
}
